import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FolderFilledSvg from "@ant-design/icons-svg/es/asn/FolderFilled";
import AntdIcon from "../components/AntdIcon";
var FolderFilled = function FolderFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FolderFilled.displayName = 'FolderFilled';
}
export default /*#__PURE__*/React.forwardRef(FolderFilled);